import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-log-data-display',
  standalone: false,
  templateUrl: './log-data-display.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./log-data-display.component.scss']
})
export class LogDataDisplayComponent {
  @Input() data: string | any = '';
  @Input() label: string = '';

  parsedData: any = null;

  ngOnInit(): void {
    this.parseData();
  }

  ngOnChanges(): void {
    this.parseData();
  }

  parseData(): void {
    if (!this.data) {
      this.parsedData = null;
      return;
    }

    try {
      // If data is a string, try to parse as JSON
      if (typeof this.data === 'string') {
        this.parsedData = JSON.parse(this.data);
      } else {
        // If it's already an object
        this.parsedData = this.data;
      }
    } catch (e) {
      // If parsing fails, keep it as string
      this.parsedData = this.data;
    }
  }

  getFieldLabel(key: string): string {
    // Convert camelCase to readable text
    const labelMap: { [key: string]: string } = {
      name: 'Imię',
      surname: 'Nazwisko',
      phone: 'Telefon',
      birthday: 'Data urodzenia',
      city: 'Miasto',
      street: 'Ulica',
      home: 'Nr domu',
      postcode: 'Kod pocztowy',
      confirm_doc: 'Numer dokumentu',
      type: 'Typ karty',
      is_verified: 'Zweryfikowany',
      accept_news: 'Akceptuje newsy',
      user_id: 'ID użytkownika',
      complementary: 'Karty wnuków',
      nr: 'Numer karty',
      valid: 'Data ważności',
      person_id: 'ID osoby',
      status: 'Status',
      created: 'Utworzono'
    };
    return labelMap[key] || key;
  }

  formatValue(value: any, key: string): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    // Handle boolean values
    if (typeof value === 'boolean') {
      return value ? 'Tak' : 'Nie';
    }

    // Handle specific fields that need formatting
    if (key === 'birthday' || key === 'valid' || key === 'created') {
      try {
        const date = new Date(value);
        if (!isNaN(date.getTime())) {
          return date.toLocaleDateString('pl-PL');
        }
      } catch (e) {
        // If date parsing fails, return as is
      }
    }

    // Handle is_verified field
    if (key === 'is_verified') {
      return value === 1 || value === '1' ? 'Tak' : 'Nie';
    }

    // Handle accept_news field
    if (key === 'accept_news') {
      return value === 1 || value === '1' ? 'Tak' : 'Nie';
    }

    // Return as string
    return String(value);
  }

  isObject(value: any): boolean {
    return typeof value === 'object' && !Array.isArray(value) && value !== null;
  }

  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
}
